// components/SnFormControls.tsx

import React from "react";
import SnLabel from "./SnLabel";
import SnFindFormContols from "./SnFindFormContols";
import { TpCtrl } from "@shared/type/CommonType";

interface Control {
  tp_ctrl: TpCtrl;
  no_line: string;
  qt_rowindex: number;
  qt_colindex: number;
  qt_rowspan: number;
  qt_colspan: number;
  nm_label?: string;
  cd_param: string;
  tp_format?: string;
  cd_displaycolumn?: string;
  cd_popup?: string;
  cd_clas?: string;
  dc_sql?: string;
}

interface Props {
  isSearchPanel?: boolean;
  isFormPanel?: boolean;
  labletype: string;
  control: Control;
  index: number;
  formData: any;
  requireds: Record<string, boolean>;
  popupCons: Record<string, any>;
  popupRef?: any;
  setRef: (line: string, node: HTMLDivElement | null) => void;
  setInputRef: (el: any, index: number, isReadOnly: boolean) => void;
  handleMoveFocus: (index: number, target: string) => void;
  onTextValueChanged: (param: string, data: string) => void;
  onNumberValueChanged: (param: string, data: number) => void;
  onPeriodValueChanged: (param: string, start: string, end: string) => void;
  onCodeValueChanged: (
    code: string,
    data: string,
    name: string,
    data2: string,
    rowData?: any
  ) => void;
  setReadOnly: (param: string) => boolean;
  onButtonClick: (param: string) => void;
  filter: Record<string, any>;
  onEnter?: (param: string, value: string) => Promise<void> | void;
  onControlFocus?: (param: string) => void;
  labelSize?: number;
}

const SnFormControls: React.FC<Props> = React.memo(
  ({
    isSearchPanel = false,
    isFormPanel = false,
    labletype,
    control,
    index,
    formData,
    requireds,
    popupCons,
    popupRef,
    setRef,
    setInputRef,
    handleMoveFocus,
    onTextValueChanged,
    onNumberValueChanged,
    onPeriodValueChanged,
    onCodeValueChanged,
    setReadOnly,
    onButtonClick,
    filter,
    onEnter,
    onControlFocus,
    labelSize,
  }) => {
    const tpCtrl = control.tp_ctrl.trim();

    return (
      <div
        key={control.no_line}
        ref={(node) => {
          setRef(control.no_line, node);
        }}
        // 포커스는 버블링되므로 내부 어떤 입력이 포커스를 받든 여기서 잡힌다
        onFocus={() => onControlFocus?.(control.cd_param)}
        className="flex justify-end"
        style={{
          position: "relative",
          gridColumn: `auto/span ${control.qt_colspan}`,
          gridRow: `auto/span ${control.qt_rowspan}`,
        }}
      >
        {control.nm_label &&
        tpCtrl != "SnGroupLabel" &&
        tpCtrl != "SnLabel" &&
        tpCtrl != "SnButton" &&
        tpCtrl != "SnSwitch" &&
        tpCtrl != "SnLinkedInfoBox" &&
        !tpCtrl.includes("AfterLabel") ? (
          <SnLabel
            text={control.nm_label}
            type={labletype}
            color={
              Object.hasOwn(requireds, control.cd_param) ? "#0b0c69" : "black"
            }
            size={labelSize}
          />
        ) : null}

        <div className="w-full">
          <SnFindFormContols
            isSearchPanel={isSearchPanel}
            isFormPanel={isFormPanel}
            control={control}
            index={index}
            formData={formData}
            requireds={requireds}
            popupCons={popupCons}
            setRef={setRef}
            setInputRef={setInputRef}
            handleMoveFocus={handleMoveFocus}
            onTextValueChanged={onTextValueChanged}
            onNumberValueChanged={onNumberValueChanged}
            onPeriodValueChanged={onPeriodValueChanged}
            onCodeValueChanged={onCodeValueChanged}
            setReadOnly={setReadOnly}
            onButtonClick={(param: string) => {
              onButtonClick != null && onButtonClick(param);
            }}
            onEnter={onEnter}
            filter={filter}
            popupRef={popupRef}
          />
        </div>
        {control.nm_label &&
        (tpCtrl.includes("AfterLabel") || tpCtrl === "SnSwitch") ? (
          <SnLabel
            text={control.nm_label}
            type={"AfterLabel"}
            color={
              Object.hasOwn(requireds, control.cd_param) ? "#0b0c69" : "black"
            }
          />
        ) : null}
      </div>
    );
  }
);

export default SnFormControls;
